(() => {
  const root = document.getElementById("wl-memory");
  if (!root || root.dataset.ready === "true") return;
  root.dataset.ready = "true";

  const $ = id => document.getElementById(id);
  const video = $("wl-camera-video");
  const photo = $("wl-camera-photo");
  const canvas = $("wl-camera-canvas");
  const fallback = $("wl-camera-fallback");
  const libraryInput = $("wl-library-input");
  const galleryPreview = $("wl-gallery-preview");
  const memoryThumb = $("wl-memory-thumb");
  const status = $("wl-camera-status");
  const toast = $("wl-toast");
  const titleInput = $("wl-memory-title-input");
  const titlePreview = $("wl-memory-title-preview");
  const timePreview = $("wl-memory-time-preview");
  const cameraStage = $("wl-camera-stage");
  const captureFlash = $("wl-capture-flash");
  const captureReview = $("wl-capture-review");
  const memoryEditor = $("wl-memory-editor");
  const reelStudio = $("wl-reel-studio");
  const saveSuccess = $("wl-save-success");
  const saveSuccessTitle = $("wl-save-success-title");

  const reelPreviewShell = $("wl-reel-preview-shell");
  const reelPreview = $("wl-reel-preview");
  const reelPreviewVideo = $("wl-reel-preview-video");
  const reelPreviewCover = $("wl-reel-preview-cover");
  const reelPreviewEmpty = $("wl-reel-preview-empty");
  const reelPreviewPlay = $("wl-reel-preview-play");
  const reelPreviewCaption = $("wl-reel-preview-caption");
  const reelPreviewTitle = $("wl-reel-preview-title");
  const reelPreviewStory = $("wl-reel-preview-story");
  const reelPreviewMark = $("wl-reel-preview-mark");
  const reelScrubber = $("wl-reel-scrubber");
  const reelCurrentTime = $("wl-reel-current-time");
  const reelDuration = $("wl-reel-duration");
  const reelStatusText = $("wl-reel-status-text");
  const reelStatusMeta = $("wl-reel-status-meta");
  const reelClipTrack = $("wl-reel-clip-track");
  const reelClipCount = $("wl-reel-clip-count");
  const reelPrimaryLabel = $("wl-reel-primary-label");
  const reelToolDrawer = $("wl-reel-tool-drawer");
  const reelToolKicker = $("wl-reel-tool-kicker");
  const reelToolTitle = $("wl-reel-tool-title");
  const reelToolBody = $("wl-reel-tool-body");
  const shutterIcon = root.querySelector(".wl-shutter b");
  const shutterButton = root.querySelector('[data-wl-action="capture"]');

  const TEMPLATE_LIBRARY = {
    "auto-highlight": {
      name: "Auto Highlight",
      icon: "✦",
      caption: "The best little moments, all in one Reel.",
      pace: "balanced",
      transition: "smart-cut"
    },
    zoomies: {
      name: "Zoomies",
      icon: "⚡",
      caption: "Maximum speed. Zero regrets. 🐾",
      pace: "fast",
      transition: "quick-cut"
    },
    "day-in-life": {
      name: "Day in the Life",
      icon: "☀",
      caption: "A very good day in a very good life.",
      pace: "story",
      transition: "soft-fade"
    },
    "training-progress": {
      name: "Training Progress",
      icon: "✓",
      caption: "Practice, patience, and one very proud pup.",
      pace: "progressive",
      transition: "step-cut"
    },
    "gotcha-day": {
      name: "Gotcha Day",
      icon: "♥",
      caption: "The day everything changed for the better.",
      pace: "emotional",
      transition: "memory-fade"
    },
    "park-recap": {
      name: "Park Recap",
      icon: "🐾",
      caption: "Friends, fresh air, and a whole lot of play.",
      pace: "playful",
      transition: "bounce-cut"
    }
  };

  let stream = null;
  let facingMode = "environment";
  let activeMode = "photo";
  let capturedDataURL = "";
  let selectedFile = null;
  let toastTimer = null;
  let mediaRecorder = null;
  let recordingStartedAt = 0;
  let recordingTimer = null;
  let reelClips = [];
  let selectedTemplate = "auto-highlight";
  let builtReel = null;
  let clipSequence = 0;
  let videoObjectURL = "";
  let selectedClipId = "";
  let activeReelTool = "clips";
  let reelPlaybackURL = "";
  let draggedClipId = "";
  let cameraState = "idle";
  let cameraStartToken = 0;
  let cameraStartPromise = null;
  let cameraWatchdogTimer = null;
  let streamFacingMode = "";
  const CAMERA_START_TIMEOUT_MS = 9000;

  const reelOptions = {
    music: true,
    captions: true,
    watermark: true,
    transitions: true
  };

  function nativeHandler() {
    return window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.WagLifeCameraIQ;
  }

  function sendNative(action, payload = {}) {
    const handler = nativeHandler();
    if (!handler || typeof handler.postMessage !== "function") return false;

    handler.postMessage({
      action,
      source: "new-memory",
      requestedAt: new Date().toISOString(),
      ...payload
    });
    return true;
  }

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("is-visible");
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove("is-visible"), 2600);
  }

  function setStatus(message) {
    if (status) status.textContent = message;
  }

  function installCameraStateStyles() {
    if (document.getElementById("wl-camera-iq-state-styles")) return;
    const style = document.createElement("style");
    style.id = "wl-camera-iq-state-styles";
    style.textContent = `
      #wl-memory .wl-shutter,
      #wl-memory [data-wl-action="flip"],
      #wl-memory [data-zoom] {
        transition: opacity .2s ease, transform .2s ease;
      }
      #wl-memory.is-camera-starting .wl-shutter,
      #wl-memory.is-camera-starting [data-wl-action="flip"],
      #wl-memory.is-camera-starting [data-zoom],
      #wl-memory.is-camera-failed [data-wl-action="flip"],
      #wl-memory.is-camera-failed [data-zoom] {
        opacity: .42;
        pointer-events: none;
      }
      #wl-memory.is-camera-live #wl-camera-video {
        opacity: 1;
      }
      #wl-memory #wl-camera-video {
        transition: opacity .28s ease;
      }
      #wl-memory:not(.is-camera-live) #wl-camera-video {
        opacity: 0;
      }
      #wl-memory #wl-camera-status {
        box-sizing: border-box;
        padding-bottom: max(10px, env(safe-area-inset-bottom));
      }
    `;
    document.head.appendChild(style);
  }

  function clearCameraWatchdog() {
    window.clearTimeout(cameraWatchdogTimer);
    cameraWatchdogTimer = null;
  }

  function setCaptureEnabled(enabled) {
    if (!shutterButton) return;
    shutterButton.disabled = !enabled;
    shutterButton.setAttribute("aria-disabled", String(!enabled));
  }

  function setCameraState(nextState, message) {
    cameraState = nextState;
    root.dataset.cameraState = nextState;
    root.classList.toggle("is-camera-starting", nextState === "requesting" || nextState === "starting");
    root.classList.toggle("is-camera-live", nextState === "live");
    root.classList.toggle("is-camera-failed", nextState === "failed");
    setCaptureEnabled(nextState === "live" || nextState === "review");
    if (message) setStatus(message);
  }

  function readyStatusForMode() {
    if (activeMode === "reel") return "Reel mode ready. Tap the paw to record a clip.";
    if (activeMode === "video") return "Video mode ready. Tap the paw to start recording.";
    return "Camera IQ is ready.";
  }

  function streamIsLive() {
    if (!stream) return false;
    const tracks = stream.getVideoTracks();
    return tracks.length > 0 && tracks.some(track => track.readyState === "live");
  }

  function waitForVideoReady(timeoutMs = CAMERA_START_TIMEOUT_MS) {
    return new Promise((resolve, reject) => {
      let settled = false;
      let timer = null;

      const cleanup = () => {
        window.clearTimeout(timer);
        video.removeEventListener("loadedmetadata", check);
        video.removeEventListener("canplay", check);
        video.removeEventListener("playing", check);
        video.removeEventListener("error", fail);
      };

      const finish = () => {
        if (settled) return;
        settled = true;
        cleanup();
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(resolve);
        });
      };

      const check = () => {
        if (video.readyState >= 2 && video.videoWidth > 0 && video.videoHeight > 0) finish();
      };

      const fail = () => {
        if (settled) return;
        settled = true;
        cleanup();
        reject(new Error("Camera preview could not start."));
      };

      video.addEventListener("loadedmetadata", check);
      video.addEventListener("canplay", check);
      video.addEventListener("playing", check);
      video.addEventListener("error", fail, { once: true });
      timer = window.setTimeout(fail, timeoutMs);
      check();
    });
  }

  function updateTimePreview() {
    if (!timePreview) return;
    const now = new Date();
    timePreview.textContent = `Today · ${now.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit"
    })}`;
  }

  function flashShutter() {
    if (!captureFlash) return;
    captureFlash.classList.remove("is-flashing");
    void captureFlash.offsetWidth;
    captureFlash.classList.add("is-flashing");
  }

  function revokeVideoObjectURL() {
    if (videoObjectURL) {
      URL.revokeObjectURL(videoObjectURL);
      videoObjectURL = "";
    }
  }

  function enterCaptureReview() {
    if (!cameraStage || !captureReview) return;
    cameraStage.classList.add("is-reviewing");
    captureReview.hidden = false;
    setStatus("Photo captured. Retake it or use this photo.");
  }

  function exitCaptureReview() {
    if (!cameraStage || !captureReview) return;
    cameraStage.classList.remove("is-reviewing");
    captureReview.hidden = true;
  }

  function activateEditor(shouldScroll = true) {
    if (!memoryEditor) return;
    memoryEditor.classList.remove("wl-editor--waiting");
    memoryEditor.classList.add("is-ready");

    if (shouldScroll) {
      window.setTimeout(() => {
        memoryEditor.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 180);
    }
  }

  function updateImagePreview(dataURL) {
    capturedDataURL = dataURL;
    selectedFile = null;
    revokeVideoObjectURL();
    photo.src = dataURL;
    photo.hidden = false;
    fallback.hidden = true;
    video.hidden = true;
    video.controls = false;

    galleryPreview.style.backgroundImage = `url("${dataURL}")`;
    galleryPreview.textContent = "";
    memoryThumb.style.backgroundImage = `url("${dataURL}")`;
    memoryThumb.textContent = "";

    flashShutter();
    setCameraState("review");
    enterCaptureReview();
    showToast("Memory captured");
  }

  async function stopCamera({ preserveState = false } = {}) {
    clearCameraWatchdog();
    window.clearInterval(recordingTimer);
    recordingTimer = null;
    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      try { mediaRecorder.stop(); } catch (_) {}
    }
    mediaRecorder = null;

    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      stream = null;
    }
    streamFacingMode = "";
    if (video && video.srcObject) video.srcObject = null;
    if (!preserveState) setCameraState("idle", "Camera IQ is paused.");
  }

  async function startBrowserCamera(startToken) {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setCameraState("failed", "Camera access is not available here. Choose from your library.");
      return false;
    }

    try {
      revokeVideoObjectURL();

      if (streamIsLive() && streamFacingMode === facingMode) {
        video.srcObject = stream;
        video.controls = false;
        video.muted = true;
        video.playsInline = true;
        video.hidden = false;
        photo.hidden = true;
        fallback.hidden = true;
        video.classList.toggle("is-front", facingMode === "user");
        await video.play();
        await waitForVideoReady();
        if (startToken !== cameraStartToken) return false;
        setCameraState("live", readyStatusForMode());
        return true;
      }

      await stopCamera({ preserveState: true });
      if (startToken !== cameraStartToken) return false;

      setCameraState("requesting", "Requesting camera access…");
      const requestedStream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: facingMode },
          width: { ideal: 1920 },
          height: { ideal: 1080 }
        },
        // Keep browser capture video-only for now. Requesting microphone access
        // inside an iOS WKWebView can terminate the app when the native shell
        // has not yet added NSMicrophoneUsageDescription.
        audio: false
      });

      if (startToken !== cameraStartToken) {
        requestedStream.getTracks().forEach(track => track.stop());
        return false;
      }

      stream = requestedStream;
      streamFacingMode = facingMode;
      setCameraState("starting", "Starting Camera IQ preview…");

      video.src = "";
      video.srcObject = stream;
      video.controls = false;
      video.muted = true;
      video.playsInline = true;
      video.loop = false;
      video.hidden = false;
      photo.hidden = true;
      fallback.hidden = true;
      video.classList.toggle("is-front", facingMode === "user");

      await video.play();
      await waitForVideoReady();

      if (startToken !== cameraStartToken) return false;
      setCameraState("live", readyStatusForMode());
      return true;
    } catch (error) {
      if (startToken !== cameraStartToken) return false;
      console.warn("WagLife Camera IQ camera error:", error);
      await stopCamera({ preserveState: true });
      setCameraState(
        "failed",
        "Camera IQ could not start. Tap the paw to try again or choose from your library."
      );
      showToast("Camera access was not available");
      return false;
    }
  }

  async function startCamera(options = {}) {
    if (cameraStartPromise && !options.force) return cameraStartPromise;

    const startToken = ++cameraStartToken;
    const skipNative = Boolean(options.skipNative);
    setCameraState("starting", "Opening Camera IQ…");

    cameraStartPromise = (async () => {
      if (!skipNative && sendNative("openCamera", { mode: activeMode, facingMode })) {
        setCameraState("starting", "Opening native Camera IQ…");
        clearCameraWatchdog();
        cameraWatchdogTimer = window.setTimeout(async () => {
          if (startToken !== cameraStartToken || cameraState === "live" || cameraState === "review") return;
          console.warn("WagLife Camera IQ native startup timed out; using web camera fallback.");
          cameraStartPromise = null;
          await startCamera({ skipNative: true, force: true });
        }, CAMERA_START_TIMEOUT_MS);
        return true;
      }

      return startBrowserCamera(startToken);
    })();

    try {
      return await cameraStartPromise;
    } finally {
      if (startToken === cameraStartToken && !cameraWatchdogTimer) cameraStartPromise = null;
    }
  }

  function capturePhoto() {
    if (cameraState !== "live") {
      showToast(cameraState === "failed" ? "Tap again to retry Camera IQ" : "Camera IQ is still opening");
      startCamera({ force: cameraState === "failed" });
      return;
    }

    if (sendNative("capture", { mode: activeMode })) {
      setStatus("Capturing with native Camera IQ…");
      return;
    }

    if (!stream || !video.videoWidth || !video.videoHeight) {
      startCamera();
      return;
    }

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext("2d");
    if (!context) return;

    context.save();
    if (facingMode === "user") {
      context.translate(canvas.width, 0);
      context.scale(-1, 1);
    }
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    context.restore();
    updateImagePreview(canvas.toDataURL("image/jpeg", 0.92));
  }

  function chooseRecorderMimeType() {
    const candidates = [
      "video/webm;codecs=vp9,opus",
      "video/webm;codecs=vp8,opus",
      "video/webm",
      "video/mp4"
    ];
    return candidates.find(type => window.MediaRecorder && MediaRecorder.isTypeSupported(type)) || "";
  }

  function recordingLabel() {
    const elapsed = Math.max(0, Date.now() - recordingStartedAt);
    const seconds = (elapsed / 1000).toFixed(1);
    setStatus(`Recording clip · ${seconds}s · tap again to stop`);
  }

  function readVideoDuration(fileOrBlob) {
    return new Promise(resolve => {
      const probe = document.createElement("video");
      const objectURL = URL.createObjectURL(fileOrBlob);
      let settled = false;

      const finish = value => {
        if (settled) return;
        settled = true;
        URL.revokeObjectURL(objectURL);
        resolve(Number.isFinite(value) ? value : 0);
      };

      probe.preload = "metadata";
      probe.muted = true;
      probe.playsInline = true;
      probe.addEventListener("loadedmetadata", () => finish(Number(probe.duration || 0)), { once: true });
      probe.addEventListener("error", () => finish(0), { once: true });
      probe.src = objectURL;
      window.setTimeout(() => finish(0), 3000);
    });
  }

  function createVideoThumbnail(fileOrBlob) {
    return new Promise(resolve => {
      const previewVideo = document.createElement("video");
      const previewCanvas = document.createElement("canvas");
      const objectURL = URL.createObjectURL(fileOrBlob);
      previewVideo.preload = "metadata";
      previewVideo.muted = true;
      previewVideo.playsInline = true;
      previewVideo.src = objectURL;

      const finish = thumbnail => {
        URL.revokeObjectURL(objectURL);
        resolve(thumbnail || "");
      };

      previewVideo.addEventListener("loadeddata", () => {
        try {
          previewVideo.currentTime = Math.min(0.2, Math.max(0, previewVideo.duration / 4));
        } catch (_) {}
      }, { once: true });

      previewVideo.addEventListener("seeked", () => {
        try {
          previewCanvas.width = previewVideo.videoWidth || 360;
          previewCanvas.height = previewVideo.videoHeight || 640;
          const context = previewCanvas.getContext("2d");
          context.drawImage(previewVideo, 0, 0, previewCanvas.width, previewCanvas.height);
          finish(previewCanvas.toDataURL("image/jpeg", 0.72));
        } catch (_) {
          finish("");
        }
      }, { once: true });

      previewVideo.addEventListener("error", () => finish(""), { once: true });
      window.setTimeout(() => finish(""), 2500);
    });
  }

  async function addReelClip(blob, metadata = {}) {
    const url = URL.createObjectURL(blob);
    const [thumbnail, measuredDuration] = await Promise.all([
      createVideoThumbnail(blob),
      metadata.duration ? Promise.resolve(Number(metadata.duration)) : readVideoDuration(blob)
    ]);
    const clip = {
      id: `clip-${Date.now()}-${++clipSequence}`,
      blob,
      url,
      thumbnail,
      name: metadata.name || `Clip ${reelClips.length + 1}`,
      type: blob.type || metadata.type || "video/webm",
      duration: Number(metadata.duration || measuredDuration || 0),
      source: metadata.source || "camera",
      createdAt: new Date().toISOString()
    };

    reelClips.push(clip);
    selectedClipId = clip.id;
    builtReel = null;
    renderClipTray();
    activateEditor(false);
    showToast(`${clip.name} added`);
    setStatus(`${reelClips.length} Reel clip${reelClips.length === 1 ? "" : "s"} ready.`);
  }

  async function toggleVideoRecording() {
    if (cameraState !== "live" && !(mediaRecorder && mediaRecorder.state === "recording")) {
      showToast(cameraState === "failed" ? "Tap again to retry Camera IQ" : "Camera IQ is still opening");
      await startCamera({ force: cameraState === "failed" });
      return;
    }

    if (sendNative("toggleRecording", {
      mode: activeMode,
      clipCount: reelClips.length,
      template: selectedTemplate
    })) {
      setStatus("Recording with native Camera IQ…");
      return;
    }

    if (!stream) {
      await startCamera();
      return;
    }

    if (!window.MediaRecorder) {
      showToast("Recording is not supported here. Add a video from your library.");
      libraryInput.click();
      return;
    }

    if (mediaRecorder && mediaRecorder.state === "recording") {
      mediaRecorder.stop();
      return;
    }

    const chunks = [];
    const mimeType = chooseRecorderMimeType();
    try {
      mediaRecorder = mimeType ? new MediaRecorder(stream, { mimeType }) : new MediaRecorder(stream);
    } catch (error) {
      console.warn("WagLife MediaRecorder error:", error);
      showToast("This camera cannot record here. Choose a video from your library.");
      return;
    }

    mediaRecorder.addEventListener("dataavailable", event => {
      if (event.data && event.data.size > 0) chunks.push(event.data);
    });

    mediaRecorder.addEventListener("stop", async () => {
      window.clearInterval(recordingTimer);
      recordingTimer = null;
      root.classList.remove("is-recording");
      if (shutterIcon) shutterIcon.textContent = "🐾";

      const duration = Math.max(0.1, (Date.now() - recordingStartedAt) / 1000);
      const blob = new Blob(chunks, { type: mediaRecorder.mimeType || mimeType || "video/webm" });
      mediaRecorder = null;

      if (activeMode === "reel") {
        await addReelClip(blob, { duration, source: "camera" });
        await startCamera();
      } else {
        selectedFile = new File([blob], `waglife-video-${Date.now()}.webm`, { type: blob.type });
        showSelectedVideo(selectedFile, true);
      }
    }, { once: true });

    recordingStartedAt = Date.now();
    mediaRecorder.start(250);
    root.classList.add("is-recording");
    if (shutterIcon) shutterIcon.textContent = "■";
    recordingLabel();
    recordingTimer = window.setInterval(recordingLabel, 100);
  }

  async function retakePhoto() {
    capturedDataURL = "";
    selectedFile = null;
    photo.src = "";
    photo.hidden = true;
    exitCaptureReview();
    memoryEditor.classList.add("wl-editor--waiting");
    memoryEditor.classList.remove("is-ready");
    await startCamera({ force: true });
  }

  function useCapturedPhoto() {
    exitCaptureReview();
    activateEditor(true);
    setStatus("Photo selected. Make the memory yours.");
    showToast("Photo added to Memory Editor");
  }

  async function chooseFromLibrary() {
    // Reel clip selection uses the browser file picker intentionally.
    // Opening a native picker while an iOS WKWebView camera stream is active
    // can terminate the host app, and `capture=environment` may launch another
    // camera session instead of the photo library.
    if (activeMode === "reel") {
      setStatus("Opening your video library…");
      await stopCamera();
      libraryInput.removeAttribute("capture");
      libraryInput.accept = "video/*";
      // Single-selection is more reliable in iOS WKWebView. Users can tap
      // Add Clips again to build a multi-clip Reel.
      libraryInput.multiple = false;
      window.setTimeout(() => libraryInput.click(), 80);
      return;
    }

    if (sendNative("chooseFromLibrary", { mode: activeMode, multiple: false })) {
      setStatus("Opening your photo library…");
      return;
    }

    libraryInput.removeAttribute("capture");
    libraryInput.multiple = false;
    libraryInput.click();
  }

  function showSelectedVideo(file, activate = true) {
    selectedFile = file;
    capturedDataURL = "";
    revokeVideoObjectURL();
    videoObjectURL = URL.createObjectURL(file);
    video.srcObject = null;
    video.src = videoObjectURL;
    video.controls = true;
    video.muted = false;
    video.loop = false;
    video.hidden = false;
    photo.hidden = true;
    fallback.hidden = true;
    galleryPreview.style.backgroundImage = "";
    galleryPreview.textContent = "▶";
    memoryThumb.style.backgroundImage = "";
    memoryThumb.textContent = "▶";
    if (activate) activateEditor(true);
    setStatus("Video selected. Trim and save it below.");
    showToast("Video added to New Memory");
  }

  async function handleLibraryFiles(files) {
    const selected = Array.from(files || []);
    if (!selected.length) return;

    if (activeMode === "reel") {
      const videos = selected.filter(file => file.type.startsWith("video/"));
      if (!videos.length) {
        showToast("Reel Studio needs video clips");
        return;
      }
      for (const file of videos.slice(0, 12)) {
        await addReelClip(file, { name: file.name || undefined, source: "library", type: file.type });
      }
      setStatus(`${reelClips.length} Reel clip${reelClips.length === 1 ? "" : "s"} ready. Tap Add Clips again for another.`);
      reelStudio.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    const file = selected[0];
    selectedFile = file;

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        updateImagePreview(String(reader.result || ""));
        exitCaptureReview();
        activateEditor(true);
      };
      reader.readAsDataURL(file);
      return;
    }

    if (file.type.startsWith("video/")) {
      showSelectedVideo(file, true);
    }
  }

  function formatClock(seconds) {
    const safe = Math.max(0, Number(seconds || 0));
    const minutes = Math.floor(safe / 60);
    const remainder = Math.floor(safe % 60);
    return `${minutes}:${String(remainder).padStart(2, "0")}`;
  }

  function formatDuration(seconds) {
    if (!Number.isFinite(seconds) || seconds <= 0) return "0:00";
    return formatClock(seconds);
  }

  function totalReelDuration() {
    return reelClips.reduce((total, clip) => total + Number(clip.duration || 0), 0);
  }

  function escapeHTML(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function revokeReelPlaybackURL() {
    if (!reelPlaybackURL) return;
    URL.revokeObjectURL(reelPlaybackURL);
    reelPlaybackURL = "";
  }

  function setReelProjectStatus(label, meta) {
    if (reelStatusText) reelStatusText.textContent = label;
    if (reelStatusMeta) reelStatusMeta.textContent = meta;
  }

  function updateReelStatus() {
    const template = TEMPLATE_LIBRARY[selectedTemplate];
    const count = reelClips.length;
    const duration = totalReelDuration();
    const label = builtReel ? "Reel Ready" : count ? "Ready to build" : "Ready for clips";
    setReelProjectStatus(
      label,
      `${count} clip${count === 1 ? "" : "s"} · ${formatClock(duration)} · ${template.name} · 9:16`
    );
    if (reelClipCount) reelClipCount.textContent = String(count);
    if (reelPrimaryLabel) reelPrimaryLabel.textContent = builtReel ? "Preview Reel" : "Build My Reel";
  }

  function syncPreviewControls() {
    if (!reelPreviewVideo) return;
    const duration = Number(reelPreviewVideo.duration || totalReelDuration() || 0);
    const current = Number(reelPreviewVideo.currentTime || 0);
    if (reelCurrentTime) reelCurrentTime.textContent = formatClock(current);
    if (reelDuration) reelDuration.textContent = formatClock(duration);
    if (reelScrubber) {
      reelScrubber.max = String(Math.max(1, duration));
      reelScrubber.value = String(Math.min(current, duration || 0));
    }
    if (reelPreviewPlay) {
      reelPreviewPlay.hidden = !reelPreviewVideo.src || !reelPreviewVideo.paused;
      reelPreviewPlay.setAttribute("aria-label", reelPreviewVideo.paused ? "Play Reel preview" : "Pause Reel preview");
    }
  }

  function loadClipIntoPreview(clip, autoplay = false) {
    if (!clip || !reelPreviewVideo) return;
    selectedClipId = clip.id;
    revokeReelPlaybackURL();

    reelPreviewVideo.pause();
    reelPreviewVideo.srcObject = null;
    reelPreviewVideo.src = clip.url;
    reelPreviewVideo.hidden = false;
    reelPreviewVideo.muted = false;
    reelPreviewVideo.controls = false;
    reelPreviewVideo.loop = false;

    if (reelPreviewCover) {
      reelPreviewCover.hidden = true;
      reelPreviewCover.removeAttribute("src");
    }
    if (reelPreviewEmpty) reelPreviewEmpty.hidden = true;
    if (reelPreviewPlay) reelPreviewPlay.hidden = false;
    if (reelPreviewCaption) reelPreviewCaption.hidden = !reelOptions.captions;
    if (reelPreviewTitle) reelPreviewTitle.textContent = titleInput.value.trim() || TEMPLATE_LIBRARY[selectedTemplate].name;
    if (reelPreviewStory) reelPreviewStory.textContent = TEMPLATE_LIBRARY[selectedTemplate].caption;
    if (reelPreviewMark) reelPreviewMark.hidden = !reelOptions.watermark;

    renderClipTray();
    if (autoplay) {
      reelPreviewVideo.play().catch(() => {});
    }
  }

  function clearReelPreview() {
    if (reelPreviewVideo) {
      reelPreviewVideo.pause();
      reelPreviewVideo.removeAttribute("src");
      reelPreviewVideo.load();
      reelPreviewVideo.hidden = true;
    }
    if (reelPreviewCover) {
      reelPreviewCover.hidden = true;
      reelPreviewCover.removeAttribute("src");
    }
    if (reelPreviewEmpty) reelPreviewEmpty.hidden = false;
    if (reelPreviewPlay) reelPreviewPlay.hidden = true;
    if (reelPreviewCaption) reelPreviewCaption.hidden = true;
    if (reelPreviewMark) reelPreviewMark.hidden = !reelOptions.watermark;
    if (reelCurrentTime) reelCurrentTime.textContent = "0:00";
    if (reelDuration) reelDuration.textContent = "0:00";
    if (reelScrubber) {
      reelScrubber.max = "100";
      reelScrubber.value = "0";
    }
  }

  function updateReelPreview() {
    updateReelStatus();

    if (!reelClips.length) {
      selectedClipId = "";
      clearReelPreview();
      return;
    }

    const selected = reelClips.find(clip => clip.id === selectedClipId) || reelClips[0];
    if (!selectedClipId) selectedClipId = selected.id;

    if (!reelPreviewVideo || reelPreviewVideo.src !== selected.url) {
      loadClipIntoPreview(selected, false);
      return;
    }

    if (reelPreviewCaption) reelPreviewCaption.hidden = !reelOptions.captions;
    if (reelPreviewMark) reelPreviewMark.hidden = !reelOptions.watermark;
    if (reelPreviewTitle) reelPreviewTitle.textContent = titleInput.value.trim() || TEMPLATE_LIBRARY[selectedTemplate].name;
    if (reelPreviewStory) reelPreviewStory.textContent = TEMPLATE_LIBRARY[selectedTemplate].caption;
    syncPreviewControls();
  }

  function renderClipTray() {
    if (!reelClipTrack) return;

    if (!reelClips.length) {
      reelClipTrack.innerHTML = `
        <button class="wl-reel-clip-add" type="button" data-wl-action="add-clips">
          <span>＋</span>
          <strong>Add your first clip</strong>
          <small>Choose a video</small>
        </button>
      `;
      updateReelPreview();
      return;
    }

    reelClipTrack.innerHTML = reelClips.map((clip, index) => `
      <button
        class="wl-reel-clip${clip.id === selectedClipId ? " is-active" : ""}"
        type="button"
        data-clip-id="${escapeHTML(clip.id)}"
        data-wl-action="preview-clip"
        draggable="true"
        ${clip.thumbnail ? `style="background-image:url('${clip.thumbnail}')"` : ""}
      >
        <span class="wl-reel-clip__meta">
          <strong>Clip ${index + 1}</strong>
          <small>${formatDuration(clip.duration)}</small>
        </span>
      </button>
    `).join("") + `
      <button class="wl-reel-clip-add" type="button" data-wl-action="add-clips">
        <span>＋</span>
        <strong>Add Clip</strong>
      </button>
    `;

    updateReelPreview();
  }

  function previewClip(clipId) {
    const clip = reelClips.find(item => item.id === clipId);
    if (!clip) return;
    loadClipIntoPreview(clip, true);
    setStatus(`${clip.name} selected.`);
  }

  function moveClip(clipId, direction) {
    const index = reelClips.findIndex(item => item.id === clipId);
    const nextIndex = index + direction;
    if (index < 0 || nextIndex < 0 || nextIndex >= reelClips.length) return;
    [reelClips[index], reelClips[nextIndex]] = [reelClips[nextIndex], reelClips[index]];
    builtReel = null;
    renderClipTray();
    showToast("Clip order updated");
  }

  function reorderClip(draggedId, targetId) {
    if (!draggedId || !targetId || draggedId === targetId) return;
    const from = reelClips.findIndex(clip => clip.id === draggedId);
    const to = reelClips.findIndex(clip => clip.id === targetId);
    if (from < 0 || to < 0) return;
    const [moved] = reelClips.splice(from, 1);
    reelClips.splice(to, 0, moved);
    builtReel = null;
    renderClipTray();
    showToast("Clip order updated");
  }

  function deleteClip(clipId) {
    const index = reelClips.findIndex(item => item.id === clipId);
    if (index < 0) return;
    const [removed] = reelClips.splice(index, 1);
    if (removed.url) URL.revokeObjectURL(removed.url);
    if (selectedClipId === clipId) {
      selectedClipId = reelClips[Math.min(index, reelClips.length - 1)]?.id || "";
    }
    builtReel = null;
    renderClipTray();
    showToast("Clip removed");
  }

  function selectTemplate(templateKey) {
    if (!TEMPLATE_LIBRARY[templateKey]) return;
    selectedTemplate = templateKey;
    builtReel = null;
    root.querySelectorAll("[data-template]").forEach(button => {
      button.classList.toggle("is-active", button.dataset.template === templateKey);
    });
    updateReelPreview();
    const template = TEMPLATE_LIBRARY[templateKey];
    setStatus(`${template.name} template selected.`);
    showToast(`${template.name} ready`);
  }

  function buildReel() {
    if (!reelClips.length) {
      showToast("Add at least one video clip first");
      setStatus("Reel Studio needs video clips before it can build a Reel.");
      return;
    }

    if (builtReel) {
      const selected = reelClips.find(clip => clip.id === selectedClipId) || reelClips[0];
      loadClipIntoPreview(selected, true);
      reelStudio.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    const template = TEMPLATE_LIBRARY[selectedTemplate];
    setReelProjectStatus(
      "Building your Reel…",
      `${reelClips.length} clip${reelClips.length === 1 ? "" : "s"} · ${template.name} · 9:16`
    );

    builtReel = {
      id: `reel-${Date.now()}`,
      template: selectedTemplate,
      clipOrder: reelClips.map(clip => clip.id),
      duration: totalReelDuration(),
      options: { ...reelOptions },
      highlightSignals: ["action", "reaction", "connection", "best-frame"],
      coverClipId: selectedClipId || reelClips[0].id,
      createdAt: new Date().toISOString()
    };

    if (sendNative("buildReel", {
      reel: builtReel,
      template,
      clips: reelClips.map(({ id, name, type, duration, source }) => ({ id, name, type, duration, source }))
    })) {
      setStatus("Camera IQ is building your Reel…");
      return;
    }

    activateEditor(false);
    if (!titleInput.value.trim() || titleInput.value === "Park Play") {
      titleInput.value = template.name;
      titlePreview.textContent = template.name;
    }
    const caption = $("wl-memory-caption");
    if (caption && !caption.value.trim()) caption.value = template.caption;

    updateReelPreview();
    setStatus(`${template.name} first cut is ready to preview.`);
    showToast("Your WagLife Reel first cut is ready");
    reelStudio.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function toggleReelOption(option) {
    if (!(option in reelOptions)) return;
    reelOptions[option] = !reelOptions[option];

    root.querySelectorAll(`[data-reel-option="${option}"]`).forEach(button => {
      button.classList.toggle("is-active", reelOptions[option]);
      button.classList.toggle("is-on", reelOptions[option]);
      button.setAttribute("aria-pressed", String(reelOptions[option]));
      const state = button.querySelector("small");
      if (state) state.textContent = reelOptions[option] ? "ON" : "OFF";
    });

    builtReel = null;
    updateReelPreview();
    showToast(`${option} ${reelOptions[option] ? "on" : "off"}`);
  }

  function openReelTool(toolButton) {
    const tool = toolButton.dataset.reelTool;
    if (!tool) return;

    activeReelTool = tool;
    root.querySelectorAll("[data-reel-tool]").forEach(button => {
      const active = button === toolButton;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", String(active));
    });

    const labels = {
      clips: ["BUILD TOOL", "Clips", "Select a clip below to preview it. Drag clips to reorder them."],
      trim: ["BUILD TOOL", "Trim", "Trim controls will apply to the selected clip. Native export can preserve exact in and out points."],
      order: ["BUILD TOOL", "Order", "Drag clips in the timeline to change the Reel sequence."],
      highlights: ["HIGHLIGHT IQ", "Highlights", "WagLife will prioritize verified action, reactions, tricks, and connection moments as detection comes online."],
      speed: ["BUILD TOOL", "Speed", "Speed controls will apply to the selected clip without changing the original video."],
      cover: ["BUILD TOOL", "Cover", "The selected clip becomes the current Reel cover source."],
      template: ["STYLE TOOL", "Template", "Choose a dog-first template from the template rail above."],
      music: ["STYLE TOOL", "Music", "Music sync is prepared for native Reel export."],
      captions: ["STYLE TOOL", "Captions", `Auto captions are ${reelOptions.captions ? "on" : "off"}.`],
      text: ["STYLE TOOL", "Text", "Add title and story text without covering your dog’s face."],
      stickers: ["STYLE TOOL", "Stickers", "Dog-first stickers and milestone marks will appear here."],
      transitions: ["STYLE TOOL", "Transitions", `Transitions are ${reelOptions.transitions ? "on" : "off"}.`],
      watermark: ["STYLE TOOL", "WagLife Mark", `The WagLife mark is ${reelOptions.watermark ? "on" : "off"}.`]
    };

    const [kicker, title, body] = labels[tool] || ["REEL TOOL", tool, "Tool selected."];
    if (reelToolKicker) reelToolKicker.textContent = kicker;
    if (reelToolTitle) reelToolTitle.textContent = title;
    if (reelToolBody) reelToolBody.textContent = body;
    if (reelToolDrawer) reelToolDrawer.hidden = false;

    if (tool === "cover" && selectedClipId) {
      const selected = reelClips.find(clip => clip.id === selectedClipId);
      if (selected && builtReel) builtReel.coverClipId = selected.id;
    }
  }

  function closeReelTool() {
    if (reelToolDrawer) reelToolDrawer.hidden = true;
  }

  function toggleReelPlayback() {
    if (!reelPreviewVideo || !reelPreviewVideo.src) {
      if (reelClips.length) loadClipIntoPreview(reelClips[0], true);
      return;
    }

    if (reelPreviewVideo.paused) {
      reelPreviewVideo.play().catch(() => {});
    } else {
      reelPreviewVideo.pause();
    }
  }

  function toggleReelMute() {
    if (!reelPreviewVideo) return;
    reelPreviewVideo.muted = !reelPreviewVideo.muted;
    showToast(reelPreviewVideo.muted ? "Reel muted" : "Reel sound on");
  }

  function openReelFullscreen() {
    if (!reelPreview) return;
    const request = reelPreview.requestFullscreen || reelPreview.webkitRequestFullscreen;
    if (request) request.call(reelPreview);
    else showToast("Full-screen preview is not available here");
  }

  function startOver() {
    if (!reelClips.length && !builtReel) {
      showToast("There is no Reel project to clear");
      return;
    }

    const confirmed = window.confirm(
      "Start over with this Reel? This clears the WagLife Reel project but does not delete the original videos from Photos."
    );
    if (!confirmed) return;

    reelClips.forEach(clip => clip.url && URL.revokeObjectURL(clip.url));
    reelClips = [];
    selectedClipId = "";
    builtReel = null;
    selectedTemplate = "auto-highlight";
    Object.assign(reelOptions, {
      music: true,
      captions: true,
      watermark: true,
      transitions: true
    });

    root.querySelectorAll("[data-template]").forEach(button => {
      button.classList.toggle("is-active", button.dataset.template === selectedTemplate);
    });
    root.querySelectorAll("[data-reel-option]").forEach(button => {
      const option = button.dataset.reelOption;
      button.classList.toggle("is-active", Boolean(reelOptions[option]));
      button.classList.toggle("is-on", Boolean(reelOptions[option]));
      button.setAttribute("aria-pressed", String(Boolean(reelOptions[option])));
      const state = button.querySelector("small");
      if (state) state.textContent = reelOptions[option] ? "ON" : "OFF";
    });

    closeReelTool();
    renderClipTray();
    setStatus("Reel project cleared. Your original videos were not deleted.");
    showToast("Ready to start a new Reel");
  }

  function saveAndShareReel() {
    if (!reelClips.length) {
      showToast("Add clips before saving");
      return;
    }
    if (!builtReel) {
      showToast("Build your Reel first");
      buildReel();
      return;
    }

    const payload = buildMemoryPayload(false);
    if (sendNative("saveAndShareReel", payload)) {
      setStatus("Preparing your Reel to save and share…");
      return;
    }

    saveMemory(false);
    window.setTimeout(() => {
      if (navigator.share) {
        navigator.share({
          title: payload.title,
          text: payload.caption || TEMPLATE_LIBRARY[selectedTemplate].caption
        }).catch(() => {});
      } else {
        showToast("Reel saved. Sharing is available in the WagLife app.");
      }
    }, 300);
  }

  async function setMode(mode, modeButton) {
    if (!["photo", "video", "memory", "reel", "portrait"].includes(mode)) return;
    if (mediaRecorder && mediaRecorder.state === "recording") mediaRecorder.stop();
    activeMode = mode;

    root.querySelectorAll("[data-mode]").forEach(button => {
      const active = button === modeButton || button.dataset.mode === mode;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-selected", String(active));
    });

    root.classList.toggle("is-reel-mode", mode === "reel");
    root.classList.toggle("is-video-mode", mode === "video");
    if (shutterIcon) shutterIcon.textContent = mode === "reel" || mode === "video" ? "●" : "🐾";

    if (mode === "reel") {
      libraryInput.removeAttribute("capture");
      libraryInput.accept = "video/*";
      libraryInput.multiple = false;
      reelStudio.scrollIntoView({ behavior: "smooth", block: "start" });
      setStatus("Reel mode selected. Record clips or add them from your library.");
    } else {
      libraryInput.accept = "image/*,video/*";
      libraryInput.multiple = false;
      setStatus(`${modeButton ? modeButton.textContent.trim() : mode} mode selected.`);
    }

    await startCamera();
  }

  function buildMemoryPayload(isDraft = false) {
    const activeTags = Array.from(root.querySelectorAll(".wl-memory-tags button.is-active"))
      .map(button => button.dataset.tag);

    return {
      isDraft,
      title: titleInput.value.trim() || "New Memory",
      pet: $("wl-memory-pet").value,
      type: $("wl-memory-type").value,
      location: $("wl-memory-location").value.trim(),
      caption: $("wl-memory-caption").value.trim(),
      tags: activeTags,
      mode: activeMode,
      hasCapture: Boolean(capturedDataURL || selectedFile || reelClips.length),
      reel: reelClips.length ? {
        selectedTemplate,
        templateName: TEMPLATE_LIBRARY[selectedTemplate].name,
        clipCount: reelClips.length,
        clips: reelClips.map(({ id, name, type, duration, source, createdAt }) => ({
          id, name, type, duration, source, createdAt
        })),
        options: { ...reelOptions },
        built: Boolean(builtReel),
        build: builtReel
      } : null
    };
  }

  function safeReadStorage(key) {
    try { return JSON.parse(localStorage.getItem(key) || "[]"); }
    catch (_) { return []; }
  }

  function saveMemory(isDraft = false) {
    const payload = buildMemoryPayload(isDraft);

    if (!payload.hasCapture) {
      showToast("Capture or choose a photo or video first");
      setStatus("Add a photo or video before saving.");
      return;
    }

    if (activeMode === "reel" && reelClips.length && !builtReel && !isDraft) {
      showToast("Build your Reel first");
      setStatus("Tap Build My Reel before saving the finished Reel.");
      reelStudio.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    if (sendNative(isDraft ? "saveDraft" : "saveMemory", payload)) {
      setStatus(isDraft ? "Saving draft…" : "Saving memory…");
      return;
    }

    const storageKey = isDraft ? "waglife_memory_drafts" : "waglife_memories";
    const current = safeReadStorage(storageKey);
    current.unshift({
      id: `wl-${Date.now()}`,
      createdAt: new Date().toISOString(),
      ...payload,
      preview: capturedDataURL || (reelClips[0] && reelClips[0].thumbnail) || ""
    });

    try {
      localStorage.setItem(storageKey, JSON.stringify(current.slice(0, 25)));
    } catch (error) {
      console.warn("WagLife storage error:", error);
      showToast("This memory is too large for browser storage. Use the WagLife app to save the original media.");
      return;
    }

    setStatus(isDraft ? "Draft saved on this device." : "Memory saved to your pet’s story.");
    showToast(isDraft ? "Memory draft saved" : "Memory saved to your pet’s story");

    if (!isDraft) {
      saveSuccessTitle.textContent = `${payload.title} is now in your dog’s story.`;
      saveSuccess.hidden = false;
      saveSuccess.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  root.addEventListener("click", async event => {
    const actionButton = event.target.closest("[data-wl-action]");
    if (actionButton) {
      const action = actionButton.dataset.wlAction;
      const clipCard = actionButton.closest("[data-clip-id]");
      const clipId = clipCard && clipCard.dataset.clipId;

      switch (action) {
        case "capture":
          if (activeMode === "video" || activeMode === "reel") await toggleVideoRecording();
          else capturePhoto();
          break;
        case "library":
        case "add-clips":
          if (action === "add-clips" && activeMode !== "reel") {
            const reelButton = root.querySelector('[data-mode="reel"]');
            await setMode("reel", reelButton);
          }
          await chooseFromLibrary();
          break;
        case "retake": await retakePhoto(); break;
        case "use-photo": useCapturedPhoto(); break;
        case "flip":
          facingMode = facingMode === "environment" ? "user" : "environment";
          await startCamera({ skipNative: true, force: true });
          break;
        case "settings":
          if (!sendNative("settings", { mode: activeMode })) showToast("Camera IQ settings are coming next");
          break;
        case "burst-tip": {
          const memoryButton = root.querySelector('[data-mode="memory"]');
          await setMode("memory", memoryButton);
          showToast("Memory mode ready");
          break;
        }
        case "dismiss-suggestion": $("wl-memory-suggestion").classList.add("is-hidden"); break;
        case "save-memory": saveMemory(false); break;
        case "save-draft": saveMemory(true); break;
        case "build-reel": buildReel(); break;
        case "preview-clip": previewClip(clipId); break;
        case "move-clip-left": moveClip(clipId, -1); break;
        case "move-clip-right": moveClip(clipId, 1); break;
        case "delete-clip": deleteClip(clipId); break;
        case "reel-play": toggleReelPlayback(); break;
        case "reel-mute": toggleReelMute(); break;
        case "reel-fullscreen": openReelFullscreen(); break;
        case "close-reel-tool": closeReelTool(); break;
        case "start-over": startOver(); break;
        case "save-and-share": saveAndShareReel(); break;
      }
    }

    const modeButton = event.target.closest("[data-mode]");
    if (modeButton) await setMode(modeButton.dataset.mode, modeButton);

    const zoomButton = event.target.closest("[data-zoom]");
    if (zoomButton) {
      root.querySelectorAll("[data-zoom]").forEach(button => {
        button.classList.toggle("is-active", button === zoomButton);
      });

      const zoom = Number(zoomButton.dataset.zoom || 1);
      const track = stream && stream.getVideoTracks()[0];
      const capabilities = track && track.getCapabilities ? track.getCapabilities() : {};
      if (track && capabilities.zoom) {
        try { await track.applyConstraints({ advanced: [{ zoom }] }); }
        catch (error) { console.warn("WagLife Camera IQ zoom error:", error); }
      }
      setStatus(`${zoom}× zoom selected.`);
    }

    const editorTool = event.target.closest("[data-editor-tool]");
    if (editorTool) {
      root.querySelectorAll("[data-editor-tool]").forEach(button => {
        button.classList.toggle("is-active", button === editorTool);
      });
      const toolName = editorTool.dataset.editorTool;
      if (toolName === "template") {
        reelStudio.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      showToast(`${toolName.charAt(0).toUpperCase() + toolName.slice(1)} tool selected`);
    }

    const reelToolButton = event.target.closest("[data-reel-tool]");
    if (reelToolButton) {
      openReelTool(reelToolButton);
      if (reelToolButton.dataset.reelOption) {
        toggleReelOption(reelToolButton.dataset.reelOption);
      }
    }

    const templateButton = event.target.closest("[data-template]");
    if (templateButton) selectTemplate(templateButton.dataset.template);

    const optionButton = event.target.closest("[data-reel-option]");
    if (optionButton && !optionButton.matches("[data-reel-tool]")) {
      toggleReelOption(optionButton.dataset.reelOption);
    }

    const tagButton = event.target.closest("[data-tag]");
    if (tagButton) tagButton.classList.toggle("is-active");
  });

  if (reelPreviewVideo) {
    reelPreviewVideo.addEventListener("loadedmetadata", syncPreviewControls);
    reelPreviewVideo.addEventListener("timeupdate", syncPreviewControls);
    reelPreviewVideo.addEventListener("play", syncPreviewControls);
    reelPreviewVideo.addEventListener("pause", syncPreviewControls);
    reelPreviewVideo.addEventListener("ended", syncPreviewControls);
  }

  if (reelScrubber) {
    reelScrubber.addEventListener("input", () => {
      if (!reelPreviewVideo || !Number.isFinite(reelPreviewVideo.duration)) return;
      reelPreviewVideo.currentTime = Math.min(
        Number(reelScrubber.value || 0),
        Number(reelPreviewVideo.duration || 0)
      );
    });
  }

  if (reelClipTrack) {
    reelClipTrack.addEventListener("dragstart", event => {
      const clip = event.target.closest("[data-clip-id]");
      draggedClipId = clip ? clip.dataset.clipId : "";
      if (event.dataTransfer && draggedClipId) {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.setData("text/plain", draggedClipId);
      }
    });

    reelClipTrack.addEventListener("dragover", event => {
      if (event.target.closest("[data-clip-id]")) event.preventDefault();
    });

    reelClipTrack.addEventListener("drop", event => {
      const target = event.target.closest("[data-clip-id]");
      if (!target) return;
      event.preventDefault();
      const sourceId = draggedClipId || (event.dataTransfer && event.dataTransfer.getData("text/plain"));
      reorderClip(sourceId, target.dataset.clipId);
      draggedClipId = "";
    });

    reelClipTrack.addEventListener("dragend", () => {
      draggedClipId = "";
    });
  }

  libraryInput.addEventListener("change", event => {
    handleLibraryFiles(event.target.files);
    event.target.value = "";
  });

  titleInput.addEventListener("input", () => {
    titlePreview.textContent = titleInput.value.trim() || "New Memory";
  });

  ["warmth", "brightness", "clarity"].forEach(name => {
    const input = $(`wl-${name}`);
    const output = $(`wl-${name}-output`);
    if (!input || !output) return;

    input.addEventListener("input", () => {
      output.textContent = input.value;
      if (photo.src && !photo.hidden) {
        const brightness = Number($("wl-brightness").value);
        const warmth = Number($("wl-warmth").value);
        const clarity = Number($("wl-clarity").value);
        const brightnessValue = 0.72 + brightness / 180;
        const saturationValue = 0.82 + clarity / 150;
        const sepiaValue = Math.max(0, (warmth - 50) / 180);
        photo.style.filter = `brightness(${brightnessValue}) saturate(${saturationValue}) sepia(${sepiaValue})`;
      }
    });
  });

  root.querySelectorAll("[data-reel-option]").forEach(button => {
    const option = button.dataset.reelOption;
    button.classList.toggle("is-active", Boolean(reelOptions[option]));
    button.classList.toggle("is-on", Boolean(reelOptions[option]));
    button.setAttribute("aria-pressed", String(Boolean(reelOptions[option])));
    const state = button.querySelector("small");
    if (state) state.textContent = reelOptions[option] ? "ON" : "OFF";
  });

  window.WagLifeCameraResult = async function(result) {
    if (!result || typeof result !== "object") return;

    clearCameraWatchdog();
    cameraStartPromise = null;

    if (result.cancelled || result.canceled) {
      setCameraState("failed", result.message || "Camera was closed. Tap the paw to try again.");
      return;
    }

    if (result.ready || result.cameraReady || result.nativeReady) {
      setCameraState("live", result.message || readyStatusForMode());
    }

    if (result.previewDataURL) updateImagePreview(result.previewDataURL);

    if (result.clipDataURL && activeMode === "reel") {
      try {
        const response = await fetch(result.clipDataURL);
        const blob = await response.blob();
        await addReelClip(blob, {
          duration: result.duration || 0,
          name: result.name,
          source: "native"
        });
      } catch (error) {
        console.warn("WagLife native clip result error:", error);
      }
    }

    if (result.message) {
      setStatus(result.message);
      showToast(result.message);
    }
  };

  window.WagLifeReelBuildResult = function(result) {
    if (!result || typeof result !== "object") return;
    if (result.success) {
      builtReel = { ...(builtReel || {}), ...result };
      updateReelPreview();
      setStatus(result.message || "Your WagLife Reel is ready.");
      showToast(result.message || "Reel ready");
    } else {
      setStatus(result.message || "We could not build that Reel.");
      showToast(result.message || "Reel could not be built");
    }
  };

  window.WagLifeMemorySaveResult = function(result) {
    if (!result || typeof result !== "object") return;
    if (result.success) {
      setStatus(result.message || "Memory saved to your pet’s story.");
      showToast(result.message || "Memory saved");
      const title = titleInput.value.trim() || "New Memory";
      saveSuccessTitle.textContent = `${title} is now in your dog’s story.`;
      saveSuccess.hidden = false;
    } else {
      setStatus(result.message || "We could not save that memory.");
      showToast(result.message || "Memory could not be saved");
    }
  };

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState !== "visible") return;
    if (capturedDataURL || selectedFile || cameraState === "review") return;
    if (!streamIsLive() && cameraState !== "starting" && cameraState !== "requesting") {
      startCamera({ force: true });
    }
  });

  window.addEventListener("pageshow", () => {
    if (capturedDataURL || selectedFile || cameraState === "review") return;
    if (!streamIsLive() && cameraState !== "starting" && cameraState !== "requesting") {
      startCamera({ force: true });
    }
  });

  window.addEventListener("beforeunload", () => {
    reelClips.forEach(clip => clip.url && URL.revokeObjectURL(clip.url));
    revokeVideoObjectURL();
    revokeReelPlaybackURL();
    stopCamera();
  });

  installCameraStateStyles();
  updateTimePreview();
  renderClipTray();
  setCameraState("starting", "Opening Camera IQ…");

  window.setTimeout(() => startCamera(), 250);
})();
